/* Currency Switcher — Birdie Shots */
(function() {
  document.querySelectorAll('.currency-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const currency = this.dataset.currency;
      document.querySelectorAll('.currency-btn').forEach(b => b.classList.remove('is-active'));
      this.classList.add('is-active');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ currency })
      }).then(() => window.location.reload());
    });
  });
})();
